import * as React from 'react';
import LinearProgress, {LinearProgressProps} from '@material-ui/core/LinearProgress/LinearProgress';
import {connect} from 'react-redux';
import Collapse from '@material-ui/core/Collapse';

export interface MapStateToProps<StoreState extends {} = {}> {
  (state: StoreState): LinearProgressProps & {inProgress};
}

export default function createTableTaskProgress<StoreState extends {} = {}>(
  mapStateToProps: MapStateToProps<StoreState>
) {
  return connect(
    mapStateToProps,
    {}
  )(({inProgress, ...props}: LinearProgressProps & {inProgress}) => (
    <Collapse
      in={inProgress}
      timeout={500}
      style={{
        position: 'absolute',
        left: 0,
        top: 0,
        right: 0,
        transitionDelay: inProgress ? '0ms' : '500ms',
      }}
      unmountOnExit
    >
      <LinearProgress variant="determinate" {...props} />
    </Collapse>
  ));
}
